import { DialogRef } from '@angular/cdk/dialog';
import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SvgComponent } from '@shared/components/svg';

@Component({
  selector: 'app-popin-container',
  imports: [SvgComponent, NgClass],
  templateUrl: './popin-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinContainerComponent {
  readonly bgColor = input<'WHITE' | 'GRAY'>('WHITE');
  readonly hasPadding = input(true);
  protected readonly dialogRef = inject(DialogRef);
}
